<template>
  <div class="main123">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model :title="title" width="1000" ref="formModel">
      <tableForm
        slot="regexList"
        ref="regexList"
        :forms="regexListForms"
        :item1="regexListItem"
        v-model="item.regexList"
        height="300"
      >
      </tableForm>
      <Button slot="btnLeft" type="error" @click="biaodashi"
        >生成表达式</Button
      >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      title: "",
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            return h("Table", {
              //局部注册组件不需要加引号
              props: {
                data: data.row.regexList,
                columns: this.regexListForms,
              },
            });
          },
        },

        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        tplId: 0,
        groupName: "",
        displayName: "",
        type: "拼车",
        price: 0,
        regexList: [],
        sort: 1,
        remark: "",
      },

      searchItem: {
        groupName: "",
        pageNumber: 1,
        pageSize: 50,
        tplId: 0, //模板条件字段节点ID
        keyWork: "",
      },
      total: 0,
      categorys: [],
      forms: [
        /*         {
          title: "模板分组字段ID",
          key: "tplId",
          required: true,
          val: 0,
          type: "InputNumber",
        }, 
        {
          title: "分组合拼条件",
          key: "groupName",
          required: true,
          readonly: true,
          type: "Input",
          type1:'textarea',
          span:24
        },*/
        {
          title: "分类",
          key: "type",
          required: true,
          type: "Select",
          selectItems: ["拼车", "包车", "其它"],
          span: 8,
        },
        /*{
          title: "价格",
          key: "price",
          required: false,
          type: "InputNumber",
          span: 8,
        },*/

        {
          title: "排序",
          key: "sort",
          required: false,
          span: 8,
          type: "InputNumber",
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          span: 8,
          type: "Input",
          span: 8,
        },
        {
          title: "表达式",
          key: "regexList",
          required: false,
          noTable: true,
          hideLabel: true,
          slotForm: "regexList",
          span: 24,
        },
      ],
      regexListItem: {
        field: "kgs",
        name: "0-100",
        min: 0,
        max: 100,
        regex: "",
        price: 0,
        //condition: "and",
      },
      regexListForms: [
        {
          title: "单位",
          key: "field",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("unit"),
          //kgs 重量，  cbm体积，  km距离
          width: 100,
        },
        {
          title: "最小值",
          key: "min",
          required: true,
          type: "InputNumber",
          width: 100,
        },
        {
          title: "最大值",
          key: "max",
          required: true,
          type: "InputNumber",
          width: 100,
        },
        {
          title: "价格",
          key: "price",
          required: true,
          type: "InputNumber",
          width: 100,
        },
        //运输费_拼车_0-150kgs/151-300kgs/0-1.00cbm/1.2-2.4cbm
        {
          title: "条件表达式",
          key: "regex",
          slotForm: "regex",
          readonly: false,
          required: true,
          type: "Input",
          width: 300,
        },

        /* {
          title: "组合条件方式",
          key: "condition",
          required: true,
          type: "Select",
          selectItems: ["and", "or"],
        }, */
      ],
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      //客户报价模板_费用明细_运费_广州-香港_拼车/kgs:54-666/cbm:23-100  你的
      //客户报价模板_费用明细_运费_广州-香港_拼车/kgs:54-666,cbm:23-100|price:20  我推荐的,万一那天做字符串切割，好弄点
    };
  },
/*   computed: {
    min() {
      //return this.item.regexList;
      var t = this.item.regexList;
      return JSON.parse(JSON.stringify(t));
    },
  },
  watch: {
    min(v) {
      console.log(v);
    },
  }, */
  methods: {
    reach(v) {
      this.item.tplId = v.id;
      this.searchItem.tplId = v.id;
      this.title = v.name;
      this.getList();
    },
    biaodashi() {
      var t = this.item.regexList;
      var name = "";
      for (let i = 0; i < t.length; i++) {
        if (t[i].field == "自定义") {
        } else {
          t[i].regex = t[i].min + "<=" + t[i].field + "<" + t[i].max;
          t[i].name = t[i].min + "-" + t[i].max;
        }

        name += "/" + t[i].name + t[i].field;
      }
      this.item.groupName = this.title + name;
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/costCondition/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          data[i]._expanded = false;
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/costCondition/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-base/costCondition/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-base/costCondition/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      if (this.utils.isEmpty(this.title)) {
        this.$Message.error("请选择节点");
        return;
      }
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojiamubanRight.vue